import { FeeIntelligence } from './feeIntelligence';

// Decisão do Rafael (27/09, "A"): cliente SEM nenhuma regra de FEE configurada (nenhuma regra em
// orcamento_fee_cliente_regra, de nenhuma versão, e nenhuma faixa de FEE por categoria) mantém o
// FEE AGÊNCIA gravado — a tela não recalcula nem zera, e o valor do FEE passa a ser digitável.
// Cliente com regra segue calculado e somente leitura. Enquanto as regras não carregaram
// ('pendente') ou falharam ('falha', bloqueio do item 10), o valor gravado também é mantido.
// Espelho da API: OrcamentoFeeAgenciaServidor::clienteSemRegraDeFee.
const decidir = ({ status = 'pendente', feeRules = [], faixasVersao = [] } = {}) => {
    if (status !== 'ok') return { recalcular: false, editavel: false };
    const temRegra = Array.isArray(feeRules) && feeRules.length > 0;
    const temCategoria = FeeIntelligence.calculateCatalogCategoryFees([], Array.isArray(faixasVersao) ? faixasVersao : []).aplicavel;
    if (temRegra || temCategoria) return { recalcular: true, editavel: false };
    return { recalcular: false, editavel: true };
};

export const FeeAgenciaManualPolicy = { decidir };
